export default __webpack_public_path__ + "static/media/logo.41edaeb7.svg";